
exports.toMapsLink = (lat, lng) => {
    if(lat && lng) 
        return `https://www.google.com/maps/place/${lat},${lng}`;
    return '';
}